import * as React from 'react';

import { LocalizedDateTime, DateTimeAccuracy } from '../misc/components/LocalizedDateTime';

interface NotificationItemProps {
    id: string;
    icon: string;
    headline: string;
    dateTime: string;

    handleClickThrough: (event, id: string) => void;
}

export const NotificationItem = (props: NotificationItemProps) => {
    const handleClick = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        props.handleClickThrough(event, props.id);
    }

    return (
        <li className="list-group-item" style={{ borderLeftColor: "#3c78b5", padding: 10 + "px", cursor: 'pointer' }} onClick={handleClick}>
            <div className="row">
                <div className="col-md-1">
                    <i className={"fas " + props.icon}></i>
                </div>
                <div className="col-md-6" style={{ overflow: "auto" }}>
                    {props.headline}
                </div>
                <div className="col-md-5">
                    <LocalizedDateTime time={props.dateTime} accuracy={DateTimeAccuracy.Second} />
                </div>
            </div>
        </li>
    );
}
